/**
 * SSORedirect - Redirects unauthenticated users to SSO
 */

import React, { useEffect } from 'react';

const SSO_URL = process.env.REACT_APP_SSO_URL || 'https://apps.iwa.web.tr';
const CURRENT_APP_URL = window.location.origin;

const SSORedirect: React.FC = () => {
  useEffect(() => {
    // Redirect to SSO with return URL
    const returnUrl = encodeURIComponent(CURRENT_APP_URL);
    window.location.href = `${SSO_URL}?returnUrl=${returnUrl}`;
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-100 to-blue-50">
      <div className="bg-white rounded-2xl shadow-xl p-10 w-full max-w-md text-center">
        {/* Logo / Title */}
        <img src="/amzsellmetrics-icon.svg" alt="" className="w-14 h-14 mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-slate-800 mb-4">AmzSellMetrics</h1>

        {/* Loading Animation */}
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-6"></div>

        <p className="text-slate-600 mb-2">Redirecting to IWA Apps SSO...</p>
        <p className="text-sm text-slate-400">You will be redirected to sign in with your Google account</p>

        {/* Manual Redirect Link */}
        <div className="mt-8 pt-6 border-t border-slate-200">
          <p className="text-sm text-slate-500 mb-3">Not redirected automatically?</p>
          <a
            href={`${SSO_URL}?returnUrl=${encodeURIComponent(CURRENT_APP_URL)}`}
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-all"
          >
            Click here to sign in
          </a>
        </div>
      </div>
    </div>
  );
};

export default SSORedirect;
